import { SimpleEnumType } from '@/types';
import { ContactsType } from '@/enums';

export namespace Contacts {
  export enum Pages {
    CONTACTS = 'contacts'
  }

  export interface Contacts {
    email: string,
    full_name: string,
    job_title: string,
    telephone: string,
  }

  export interface Links {
    title: string,
    url: string,
  }

  export interface Card {
    button_name: string,
    is_show_button: boolean,
    contact: Contacts,
    department: string,
    description: string,
    id: number,
    links: Links[],
    sub_department: string,
    type: SimpleEnumType<ContactsType>
    url: string,
  }

  export interface CardItems {
    id: number,
    sub_department: string,
  }
}
export interface Styles {
  card: string;
  cardSecondary: string;
}

export interface SendAppeal {
  [key: string]: unknown,
  title: string,
  description: string,
  mail_to: string,
  files?: Blob[]
}
